import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import { OffersReorderBody } from "./offersReorder.types";

export const requestOffersReorder = async ({
  offerId,
  newOrder
}: OffersReorderBody): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesOffers.SpecialOffers,
      offerId,
      ApiRoutesOffers.OffersReorder
    ),
    { newOrder }
  );
};
